import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionTypeIconAudioRecording = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-1_80556_417",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M3 12C3 7.02944 7.02944 3 12 3V3C16.9706 3 21 7.02944 21 12V12C21 16.9706 16.9706 21 12 21V21C7.02944 21 3 16.9706 3 12V12Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 12M21 12M21 12M3 12M12 3M21 12M12 21M3 12M12 21V19C8.13401 19 5 15.866 5 12H3H1C1 18.0751 5.92487 23 12 23V21ZM21 12H19C19 15.866 15.866 19 12 19V21V23C18.0751 23 23 18.0751 23 12H21ZM12 3V5C15.866 5 19 8.13401 19 12H21H23C23 5.92487 18.0751 1 12 1V3ZM12 3V1C5.92487 1 1 5.92487 1 12H3H5C5 8.13401 8.13401 5 12 5V3Z",
			fill: "currentColor",
			mask: "url(#path-2-inside-1_80556_417)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 12C8 9.79086 9.79086 8 12 8V8C14.2091 8 16 9.79086 16 12V12C16 14.2091 14.2091 16 12 16V16C9.79086 16 8 14.2091 8 12V12Z",
			fill: "currentColor"
		})
	]
});
export default SvgQuestionTypeIconAudioRecording;
